export const logoViewBox = '0 0 750 796';

export const logoMint = '#a8f7db';
export const logoNavy = '#111a2d';

export const outerHexPath = `
  M382 781.5
  L51.5 590
  L51.5 211
  L380 18.5
  L709.5 211
  L709.5 590
  Z
`;

export const framePath = `
  M382 781.5
  L51.5 590
  L51.5 211
  L380 18.5
  L709.5 211
  L709.5 590
  Z
  M381.5 756
  L687.5 577
  L687.5 223
  L381 43.5
  L73.5 223
  L73.5 577
  Z
`;

export const innerHexPath = `
  M381.5 756
  L687.5 577
  L687.5 223
  L381 43.5
  L73.5 223
  L73.5 577
  Z
`;

export const sPath = `
  M369 707.5
  L108.5 556
  L111 367.5
  L192.5 415
  L192.5 508
  L285.5 560
  L285.5 443
  L108.5 340
  L108.5 244
  L367 91.5
  L369.5 366
  L285.5 319
  L285 238.5
  L193.5 292
  L368.5 394
  Z
`;

export const fPath = `
  M393 708.5
  L394 91.5
  L652.5 244
  L651 339.5
  L475.5 239
  L475.5 393
  L652 393.5
  L652.5 478
  L477 478.5
  L475.5 660
  Z
`;
